import { render, staticRenderFns } from "./EchartsColumn.vue?vue&type=template&id=52ad30d3&"
import script from "./EchartsColumn.vue?vue&type=script&lang=js&"
export * from "./EchartsColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports